/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import NumberFormat from "react-number-format"
import axios from "axios";
// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from "reactstrap";

const products = [
  {
    accountType: 1,
    accountNumber: "000123456789",
    secuence: 1,
    system: 30,
    balance: 2000000
  },
  {
    accountType: 2,
    accountNumber: "000789456123",
    secuence: 1,
    system: 30,
    balance: 2000000
  },
  {
    accountType: 1,
    accountNumber: "000147852369",
    secuence: 1,
    system: 30,
    balance: 2000000.25
  },
  {
    accountType: 3,
    accountNumber: "00015963247",
    secuence: 1,
    system: 30,
    balance: 2000000
  }
];

const CardProduct = props => {
  if (props.product.accountType === 1) {
    return (
      <Col lg="6" xl="4" className="pt-4">
        <NavLink
          to="/admin/product/account-movements"
          tag={NavLinkRRD}
          activeClassName="active"
        >
          <Card className="mb-xl-0 shadow" to="/admin/product/movements">
            <CardBody className="pb-1">
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h2"
                    className="text-uppercase mb-4 font-weight-bold"
                  >
                    {props.product.accountType === 1 ? 'Cuenta Ahorros' : props.product.accountType === 2 ? 'Prestamo' : 'Cuenta Corriente'}
                  </CardTitle>
                  <span className="mb-0 h4 text-muted">
                    No. {props.product.accountNumber}
                  </span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-green text-white rounded-circle shadow">
                    <i className="ni ni-credit-card" />
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <div className="col">
                  <span className="h4">Disponible</span>
                </div>
                <Col className="col-auto">
                  <span className="text-nowrap text-success ">
                    <NumberFormat value={props.product.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                  </span>
                </Col>
              </Row>
              <hr className="mb-0" />
              <Row className="mt-2">

                <PayButton product={props.product}></PayButton>
              </Row>
            </CardBody>
          </Card>
        </NavLink>
      </Col>

    );
  } else {
    return (
      <Col lg="6" xl="4" className="pt-4">
        <NavLink
          to="/admin/product/loan-movements"
          tag={NavLinkRRD}
          activeClassName="active"
        >
          <Card className="mb-xl-0 shadow">
            <CardBody className="pb-1">
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h2"
                    className="text-uppercase mb-4 font-weight-bold"
                  >
                    {props.product.accountType === 1 ? 'Cuenta Ahorros' : props.product.accountType === 2 ? 'Prestamo' : 'Cuenta Corriente'}
                  </CardTitle>
                  <span className="mb-0 h4 text-muted">
                    No. {props.product.accountNumber}
                  </span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-green text-white rounded-circle shadow">
                    <i className="ni ni-credit-card" />
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <div className="col">
                  <span className="h4">Disponible</span>
                </div>
                <Col className="col-auto">
                  <span className="text-nowrap text-success ">
                    <NumberFormat value={props.product.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                  </span>
                </Col>
              </Row>
              <hr className="mb-0" />
              <Row className="mt-2">
                <PayButton product={props.product}></PayButton>
              </Row>
            </CardBody>
          </Card>
        </NavLink>
      </Col>

    );
  }

};

const PayButton = props => {
  if (props.product.accountType === 2) {
    return( 
      <NavLink
            to="/admin/pays"
            tag={NavLinkRRD}
            activeClassName="active"
            className="btn-block mb-2"
          >
      <button
        className="text-white bg-gradient-mycolor font-weight-bold btn btn-block btm-lg"
      >
        Pagar
  </button>
  </NavLink>)
  } else
    return( 
      <NavLink
            to="/admin/transfers"
            tag={NavLinkRRD}
            activeClassName="active"
            className="btn-block mb-2"
          >
      <button
        className="text-white bg-gradient-mycolor font-weight-bold btn btn-block btm-lg"
      >
        Transferir
  </button>
  </NavLink>)
}

const ProductsCard = () => {
  return (
    <>
      <div className="pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row>
              {products.map(product => {
                return <CardProduct product={product} key={product.accountNumber} />
              })}
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ProductsCard;
